import React, {useState, useEffect} from 'react';

import {
    ChatBubbleBottomCenterTextIcon,
} from '@heroicons/react/20/solid';

import {Button, Spinner, Modal} from 'player-components';

import { Rating } from 'react-simple-star-rating'


import './style.css';


const FeedbackModal = ({onClose, onSubmit}) => {

    const [feedbackText, setFeedbackText] = useState('');
    const [usabilityRating, setUsabilityRating] = useState(null);
    const [audioRating, setAudioRating] = useState(null);
    const [designRating, setDesignRating] = useState(null);



    const renderContent = () => {
        return <div>
        
        <div className="ratingTable">
            <div className="rating">
                <label>Usability</label>
                <Rating onClick={setUsabilityRating} ratingValue={usabilityRating} />
            </div>
            <div className="rating">
                <label>Audio quality</label>
                <Rating onClick={setAudioRating} ratingValue={audioRating} />
            </div>
            <div className="rating">
                <label>Design</label>
                <Rating onClick={setDesignRating} ratingValue={designRating} />
            </div>
            <textarea autoFocus={false} placeholder="Any other comments or suggestions?" onChange={(e)=>setFeedbackText(e.target.value)} className="textAreaInput"></textarea>
        </div>
        </div>
    }

    const handleClose = () => {
        onClose()
    }

    const handleSubmit = () => {
        onSubmit({
            feedbackText,
            usabilityRating,
            audioRating,
            designRating
        })
    }

return <Modal 
    isOpen={true}
    title="We'd love to you know what you think"
    content={renderContent()}
    confirmLabel="Submit"
    
    closeLabel="No thanks"
    onClose={handleClose}
    onConfirm={handleSubmit}
    autoFocus={false}
    />

}


export default FeedbackModal;